import { dashboardRangeForPreset } from './dashboardDateRange';
import type { DateRangePickerPreset } from '@shigo-ui/ui';

import { dashboardT } from '@/lib/messages';
import { DashboardDatePreset } from './model';

export function dashboardPresets(): DateRangePickerPreset[] {
  const labels = {
    [DashboardDatePreset.Today]: 'dashboard.date.today',
    [DashboardDatePreset.Yesterday]: 'dashboard.date.yesterday',
    [DashboardDatePreset.ThisWeek]: 'dashboard.date.thisWeek',
    [DashboardDatePreset.Last7Days]: 'dashboard.date.last7Days',
    [DashboardDatePreset.ThisMonth]: 'dashboard.date.thisMonth',
    [DashboardDatePreset.Last30Days]: 'dashboard.date.last30Days',
    [DashboardDatePreset.LastMonth]: 'dashboard.date.lastMonth',
    [DashboardDatePreset.Last3Months]: 'dashboard.date.last3Months',
  } as const;
  return Object.values(DashboardDatePreset).map((preset) => ({
    key: preset,
    label: dashboardT(labels[preset]),
    getValue: () => dashboardRangeForPreset(preset),
  }));
}
